import React from 'react';
import Button from './Button';
import BlockTitle from './BlockTitle';

const FinishStage = ({ onSave, onCancel, investmentStage }) => {
  return (
    <div className="font-figtree max-h-[calc(100vh-40px)]">
      <BlockTitle className="text-[22px]">
        Zakończenie etapu
      </BlockTitle>
      <BlockTitle className="text-[18px] mb-4 mt-8">
        Czy na pewno chcesz zakończyć etap {investmentStage}?
      </BlockTitle>

      <div className="col-span-2 flex justify-end space-x-2 pb-8 mt-10">
        <Button type="submit" variant="default" onClick={onSave}>
          Tak
        </Button>
        <Button type="button" variant="bordered" onClick={onCancel}>
          Nie
        </Button>
      </div>
    </div>
  );
};

export default FinishStage;
